import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/ui-kit";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Search, Inbox } from "lucide-react";

// Liste générique du module Vente itinérante : columns = [{ key, label, render? }]
export default function ViList({ title, subtitle, endpoint, columns, actions, filter, reloadKey, testid }) {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const load = () => api.get(endpoint).then((r) => setItems(filter ? r.data.filter(filter) : r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, [endpoint, reloadKey]); // eslint-disable-line react-hooks/exhaustive-deps
  const shown = (items || []).filter((it) => !q || JSON.stringify(it).toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid={testid}>
      <PageHeader title={title} subtitle={subtitle}>{actions}</PageHeader>
      <div className="relative mb-4 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filtrer…" className="pl-9" data-testid={`${testid}-filter`} />
      </div>
      {items === null ? <Loader /> : shown.length === 0 ? <EmptyState icon={Inbox} title="Aucun élément" subtitle="Rien à afficher pour le moment." /> : (
        <div className="rounded-xl border bg-white overflow-hidden">
          <div className="overflow-x-auto scrollbar-thin">
            <Table>
              <TableHeader><TableRow className="bg-slate-50">{columns.map((c) => <TableHead key={c.key}>{c.label}</TableHead>)}</TableRow></TableHeader>
              <TableBody>
                {shown.map((it, i) => (
                  <TableRow key={it.id || i} data-testid={`${testid}-row-${i}`}>
                    {columns.map((c) => <TableCell key={c.key} className="text-sm">{c.render ? c.render(it, load) : (it[c.key] ?? "—")}</TableCell>)}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      )}
    </div>
  );
}
